export const colors = {
  brand10: '#e6edf9',
  brand75: '#B3D4FF',
  brand100: '#004ac2',
  brand300: '#0065FF',
  neutralDark500: '#42526E',
  neutralDark600: '#344563',
  neutralDark800: '#172B4D',
  neutralLight0: '#ffffff',
  neutralLight20: '#f4f5f7',
  neutralLight30: '#ebecf0',
  neutralLight40: '#dfe1e6',
  neutralLight50: '#c1c7d0',
  signalError100: '#e12d39',
  signalInformative100: '#001d4d',
  signalSuccess100: '#27ab83',
  signalWarning100: '#fdd333',
  orange: '#FEC32D',
  red50: '#FFEBE6',
  red500: '#BF2600'
}

export const fonts = {
  roboto: { fontFamily: 'Roboto' }
}

export const type = {
  m: { fontSize: '1.5rem', lineHeight: '1.75rem' },
  xs: { fontSize: '0.875rem', lineHeight: '1.25rem' }
}

const spacingXXXS = '0.286rem'
const spacingXXS = '0.571rem'
const spacingXS = '1.142857rem'
const spacingS = '1.714rem'
const spacingM = '2.286rem'
const spacingL = '2.857rem'

export const spacing = {
  xxxs: spacingXXXS,
  xxs: spacingXXS,
  xs: spacingXS,
  s: spacingS,
  m: spacingM,
  l: spacingL,
  icon: spacingS,
  padding: {
    xxs: {
      paddingTop: spacingXXS,
      paddingLeft: spacingXXS,
      paddingBottom: spacingXXS,
      paddingRight: spacingXXS
    },
    xs: {
      paddingTop: spacingXS,
      paddingLeft: spacingXS,
      paddingBottom: spacingXS,
      paddingRight: spacingXS
    },
    m: {
      paddingTop: spacingM,
      paddingLeft: spacingM,
      paddingBottom: spacingM,
      paddingRight: spacingM
    }
  },
  paddingX: {
    xxs: { paddingRight: spacingXXS, paddingLeft: spacingXXS },
    xs: { paddingRight: spacingXS, paddingLeft: spacingXS },
    s: { paddingRight: spacingS, paddingLeft: spacingS },
    m: { paddingRight: spacingM, paddingLeft: spacingM }
  },
  paddingY: {
    xxs: { paddingTop: spacingXXS, paddingBottom: spacingXXS },
    xs: { paddingTop: spacingXS, paddingBottom: spacingXS }
  },
  margin: {
    m: { margin: spacingM }
  },
  marginX: {
    xs: { marginRight: spacingXS, marginLeft: spacingXS }
  },
  marginY: {
    xs: { marginTop: spacingXS, marginBottom: spacingXS },
    m: { marginTop: spacingM, marginBottom: spacingM }
  }
}

export const shadows = {
  xs: {
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)'
  }
}

export const rounded = {
  s: { borderRadius: '2px' },
  m: { borderRadius: '4px' }
}

export const paddingButton = {
  small: '0.5rem 0.643rem',
  smallPlus: '0.643rem 0.786rem',
  medium: '0.786rem 1.357rem',
  mediumPlus: '0.929rem 1.5rem'
}

export const appHeaderHeight = '56px'
